// extracted by mini-css-extract-plugin
export default {"img":"ProductImage_img__VP8pR"};